import NotificationSettingsTab from './notification-settings';

export default NotificationSettingsTab;
